import { defineStore } from "pinia";
import { computed, ComputedRef, reactive } from "vue";

import { Domain } from "@Modules/urls/Data/Models/DomainModel";


interface iXDomain {
  initializeFromState(currentDomain: Domain | null, otherDomains: Domain[], nameservers?: string[]): void;
  availableDomains: ComputedRef<Domain[]>;
  currentDomain: ComputedRef<Domain | null>;
  nameservers: ComputedRef<string[]>;
}

/**
 * The XDomainsStore pinia store provides with domain information. Mostly used when
 * shortening URLs.
 */
export const XDomainsStore = defineStore("x-domain", (): iXDomain => {

  /**
   * Data
   */
  type State = {
    otherDomains: Domain[],
    currentDomain: Domain | null,
    nameservers: string[],
  };
  const state = reactive<State>({
    otherDomains: [],
    currentDomain: null,
    nameservers: [],
  });

  /**
   * Getters
   */
  const currentDomain = computed(() => state.currentDomain);
  const nameservers = computed(() => state.nameservers);
  const availableDomains = computed(() => {
    const others = Array.isArray(state.otherDomains) ? state.otherDomains : [];
    if (!currentDomain.value) {
      return others;
    }
    const filtered = others.filter(d => d.domain !== currentDomain.value?.domain);
    return [currentDomain.value, ...filtered];
  });

  /**
   * Actions
   */
  function initializeFromState(currentDomain: Domain | null, otherDomains: Domain[], nameservers: string[] = []): void {
    state.currentDomain = currentDomain;
    state.otherDomains = otherDomains;
    state.nameservers = nameservers;
  }

  return {
    initializeFromState,
    availableDomains,
    currentDomain,
    nameservers,
  };
});
